export class DoughnutModel
{
    CategoryName : string;
    TotalCategoryCount : string;
    CategoryCount : string;
    CategoryPercentage : string;
    CategoryObservation : string;
    CategoryNameList : string;
    CategoryId : number;
    SubCategoryCount : number;
}
export class CategoryData
{
    CategoryId : number;
    CategoryName : string;
    CategoryTicketCount : number;
    CategoryPercentage : number;
    CategoryObservation : string;
    SubCategoryDetails : any[];
    severityData: any;
    CategoryNameList:CategoryData[];
    AllCategoryDetails: any;
}